/* eslint-disable @next/next/no-img-element */
import * as React from 'react';
import clsx, { ClassValue } from 'clsx';
import { getRandomColor } from '@/lib';
import { Typography } from '../typography';
import Image from 'next/image';

type AvatarProps = {
	photoUrl: string;
	size?: 'extra-small' | 'small' | 'medium' | 'large';
	className?: ClassValue;
	firstname?: string;
	lastname?: string;
};

export const Avatar: React.FC<AvatarProps> = ({
	photoUrl,
	size,
	className,
	firstname,
	lastname,
}) => {
	const getSizeInPixels = (size: AvatarProps['size'] = 'medium'): number => {
		switch (size) {
			case 'extra-small':
				return 24;
			case 'small':
				return 32;
			case 'medium':
				return 48;
			case 'large':
				return 64;
			default:
				return 32;
		}
	};

	return (
		<div
			className={clsx(
				'rounded-full ring-2 ring-white flex-shrink-0',
				{ 'w-6 h-6': size === 'extra-small' },
				{ 'w-8 h-8': size === 'small' },
				{ 'w-12 h-12': size === 'medium' },
				{ 'w-16 h-16': size === 'large' },
				className
			)}
			style={{
				backgroundColor: getRandomColor(firstname || 'N', lastname || 'N'),
			}}
		>
			{photoUrl ? (
				<Image
					src={photoUrl}
					alt="avatar"
					priority
					width={getSizeInPixels(size)}
					height={getSizeInPixels(size)}
					className="object-cover h-full w-full rounded-full bg-dark-10"
					quality={50}
					fetchPriority="high"
				/>
			) : (
				<div className="flex justify-center items-center h-full w-full">
					<Typography
						type={size === 'extra-small' ? 'semibold-12' : 'semibold-14'}
						className="text-white uppercase"
					>
						{firstname || lastname
							? `${firstname?.charAt(0)}${lastname?.charAt(0)}`
							: 'NN'}
					</Typography>
				</div>
			)}
		</div>
	);
};
